<template>
  <div class="banner-card">
    <div class="banner-image" :style="{ backgroundImage: `url(${src})` }" />
    <Logo
      v-if="logo"
      class="logo"
      :file="logo"
      @click.native="$emit('logo:click')"
    />
    <b-container class="content-wrapper">
      <b-row align-h="center">
        <b-col cols="12" md="10" class="content">
          <slot />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style lang="scss">
.banner-card {
  margin-bottom: rem(30px);
  padding-top: rem(240px);
  width: 100%;

  .banner-image {
    position: absolute;
    top: 0%;
    width: 100%;
    height: rem(500px);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;

    &::after {
      position: absolute;
      content: "";
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      background: rgba(0, 0, 0, 0.4);
    }
  }

  @include respond-to("medium") {
    margin-bottom: rem(10px);
  }

  @include respond-min("medium") {
    background-size: cover;
  }

  .logo {
    position: absolute;
    z-index: 1;
    top: rem(60px);
    left: 50%;
    width: rem(285px);
    margin-left: rem(math.div(-285px, 2));
    cursor: pointer;
  }

  .content-wrapper {
    position: relative;

    @include respond-to("medium") {
      padding: rem(30px);
    }
  }

  .content {
    @include setColor(--color-background1, background-color);
    border-radius: 5px;
    min-height: rem(230px);
    z-index: 1;
  }
}
</style>

<script>
import Logo from "../../ui/Logo/Logo";
export default {
  name: "BannerCard",

  components: {
    Logo,
  },

  props: {
    logo: {
      type: String,
      required: false,
    },
    src: {
      type: String,
      required: true,
    },
  },
};
</script>
